import http from '../../../utils/fetch';

export default {
    query(v) {
        return http({
            url: '/api/swyl/v1/domestic/userReceDomestic/selectPage',
            method: 'post',
            params: v
        });
    },
    queryRecord(v) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/selectPage',
            method: 'post',
            params: v
        });
    },
    queryTiaopeiCredit(usercode) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/queryTiaopeiCredit',
            method: 'post',
            params: {usercode}
        });
    },
    queryOrder(v) {
        return http({
            url: '/api/swyl/v1/bsc/orderData/selectPage',
            method: 'post',
            params: v
        });
    },
    saveCreate(v) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/saveCreate',
            method: 'post',
            params: v
        });
    },
    commitCreate(v) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/verity',
            method: 'post',
            params: v
        });
    },
    getUser() {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/getUser',
            method: 'post',
        });
    },
    getCredit(v) {
        return http({
            url: '/api/swyl/v1/infoCredit/viewInfoCredit/selectList',
            method: 'post',
            params: v
        });
    },
    selectMoneyCash(v) {
        return http({
            url: '/api/swyl/v1/infoCredit/viewSellMoneyCredit/selectOneList',
            method: 'post',
            params: v
        });
    },
    queryForeign(v) {
        return http({
            url: '/api/swyl/v1/foreign/userReceForeign/queryForeignPage',
            method: 'post',
            params: v
        });
    },
    queryByTiaoPeiCredit(v) {
        var usercode = v.usercode;
        var kkber = v.kkber;
        var creCategory = v.creCategory;
        var productId = v.productId;
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/queryByTiaoPeiCredit',
            method: 'post',
            params: {usercode, kkber, creCategory, productId}
        });
    },
    tiaoPeiCredit(tiaoPeiCreditVo) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/tiaoPeiCredit',
            method: 'post',
            data: tiaoPeiCreditVo
        });
    },
    queryCredit(id) {
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/selectById',
            method: 'post',
            params: {id}
        });
    },
    querySapAccount(v) {
        return http({
            url: '/api/swyl/v1/chengben/sapzxdswylaccount/querySapAccountPage',
            method: 'post',
            params: v
        });
    },
    exchange(foreignCurrency,currency){
        return http({
            url: '/api/swyl/v1/infoCredit/userInfoCredit/exchange',
            method: 'post',
            params: {foreignCurrency,currency}
        });
    },
	getSapCredit(param){
		return http({
		    url: '/api/swyl/v1/infoCredit/userInfoCredit/getSapCredit',
		    method: 'post',
		    params: param
		});
	},
	updateSapCredit(param){
		return http({
		    url: '/api/swyl/v1/infoCredit/userInfoCredit/updateSapCredit',
		    method: 'post',
		    params: param
		});
	},
	synSapCredit(param){
		return http({
		    url: '/api/swyl/v1/infoCredit/userInfoCredit/synSapCredit',
		    method: 'post',
			params: param
		});
	},
    getContrastSap(param){
        return http({
            url: '/api/swyl/v1/demo/userInfoCreditContrastSap/selectPage',
            method: 'post',
            params: param
        });
    }
}